var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.overviewData.length)?_c('div',{staticClass:"knowledge-study-level"},[_vm._m(0),_c('div',{staticClass:"knowledge-chart",attrs:{"id":"stuChart"}})]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level-title"},[_c('div',{staticClass:"level-title__left"},[_c('p',{staticClass:"left-line"}),_c('p',{staticClass:"left-text"},[_c('span',{staticClass:"text-bg"},[_vm._v("学业等级分布")])])])])
}]

export { render, staticRenderFns }